module.exports = __webpack_public_path__ + "static/tax-mobile-30e593c43c55ab8094c2b2fcc3626c0f.png";